/**
 * Vuex module for the custom Swal-style dialog (v-dialog).
 * Holds current dialog options. The resolve callback is stored in a
 * module-level variable so the dialog component can resolve the promise.
 */

let pendingResolve = null;

const state = {
    visible: false,
    title: "",
    text: "",
    html: "",
    type: "info",
    showCancelButton: false,
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    showCloseButton: false,
    closeButtonText: "Close",
    showLoaderOnConfirm: false,
    showDenyButton: false,
    denyButtonText: "No",
    timer: null,
    position: "center",
    toast: false,
    input: null,
    inputOptions: {},
    inputPlaceholder: "",
    inputValue: "",
};

const mutations = {
    SHOW(state, options) {
        state.visible = true;
        state.title = options.title || "";
        state.text = options.text || "";
        state.html = options.html != null ? options.html : "";
        state.type = options.type || "info";
        state.showCancelButton = !!options.showCancelButton;
        state.confirmButtonText = options.confirmButtonText || "OK";
        state.cancelButtonText = options.cancelButtonText || "Cancel";
        state.showCloseButton = !!options.showCloseButton;
        state.closeButtonText = options.closeButtonText || "Close";
        state.showLoaderOnConfirm = !!options.showLoaderOnConfirm;
        state.showDenyButton = !!options.showDenyButton;
        state.denyButtonText = options.denyButtonText || "No";
        state.timer = options.timer != null ? options.timer : null;
        state.position =
            options.position && typeof options.position === "string"
                ? options.position
                : "center";
        state.toast = !!options.toast;
        state.input = options.input || null;
        state.inputOptions = options.inputOptions || {};
        state.inputPlaceholder = options.inputPlaceholder || "";
        state.inputValue = "";
    },
    SET_INPUT_VALUE(state, value) {
        state.inputValue = value;
    },
    HIDE(state) {
        state.visible = false;
        pendingResolve = null;
    },
};

const actions = {
    show({ commit }, { options, resolve }) {
        pendingResolve = resolve;
        commit("SHOW", options);
    },
    resolve({ commit }, result) {
        if (typeof pendingResolve === "function") {
            pendingResolve(result);
        }
        commit("HIDE");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
